module.exports = __webpack_public_path__ + "jquery-ui.f83ea656979785a54937.svg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/jquery-ui.svg?uyccen
// module id = ../../../../../client/assets/fonts/jquery-ui.svg?uyccen
// module chunks = styles